export default "__VITE_ASSET__BgEl5Bex__"